var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 29,
    viewBox: "0 0 33 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33 22.4091V9.22729C32.9978 7.47991 32.2728 5.8047 30.984 4.56911C29.6951 3.33354 27.9477 2.63846 26.125 2.63636H17.149C16.9363 2.63785 16.726 2.59277 16.5344 2.50454L12.1949 0.416546C11.622 0.143082 10.9909 0.000509269 10.351 0H6.875C5.0523 0.00209309 3.30489 0.697164 2.01605 1.93274C0.727213 3.16833 0.00218331 4.84354 0 6.59092V22.4091C0.00218331 24.1565 0.727213 25.8317 2.01605 27.0673C3.30489 28.3029 5.0523 28.998 6.875 29H26.125C27.9477 28.998 29.6951 28.3029 30.984 27.0673C32.2728 25.8317 32.9978 24.1565 33 22.4091ZM2.75 7.9091V6.59092C2.75 5.5421 3.1846 4.53625 3.95818 3.79463C4.73177 3.053 5.78098 2.63636 6.875 2.63636H10.351C10.5642 2.63694 10.7744 2.68428 10.9656 2.77477L15.3051 4.85619C15.8779 5.12966 16.5091 5.27223 17.149 5.27273H26.125C26.9752 5.27612 27.8033 5.53121 28.4965 6.00312C29.1896 6.47505 29.7136 7.14073 29.997 7.9091H2.75ZM30.25 10.5455V22.4091C30.25 23.458 29.8154 24.4639 29.0418 25.2055C28.2682 25.9471 27.219 26.3636 26.125 26.3636H6.875C5.78098 26.3636 4.73177 25.9471 3.95818 25.2055C3.1846 24.4639 2.75 23.458 2.75 22.4091V10.5455H16.5H30.25Z",
    fill: "#1D1D17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.d9deed9bfb0efa8ae11ee6447cad6b53.svg";
export { ForwardRef as ReactComponent };